export enum LabelType {
  UPC = 'UPC',
  Shoebox = 'SHOEBOX',
  CGrade = 'CGRADE',
  BlindILPN = 'BLINDILPNV3',
  UpcRFID = 'UPCRFID',
}
